// extracted by mini-css-extract-plugin
export default {"systemLandscapeHeader":"SystemLandscapeSection_systemLandscapeHeader__N023L"};